<section class="relative flex flex-col items-center w-full min-w-0 overflow-x-hidden">
  <div class="relative flex flex-col w-full max-w-5xl gap-6 px-2 sm:px-3">
  <header class="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3">
    <div class="min-w-0">
    <h1 class="text-xl sm:text-2xl font-semibold text-gray-900">KBIS</h1>
    <p class="text-sm text-gray-500 mt-1">Gérez et consultez votre extrait KBIS.</p>
    </div>
    <label class="inline-flex w-full sm:w-auto items-center justify-center gap-2 px-4 py-2.5 sm:py-2 bg-secondary text-white text-sm font-medium rounded-md cursor-pointer hover:bg-secondary-hover shrink-0">
      <span class="material-symbols-outlined text-[16px]">upload</span>
      @if (uploading()) { Upload... } @else { Ajouter un KBIS }
      <input type="file" class="hidden" (change)="onFileSelected($event)" [disabled]="uploading()" accept=".pdf,.png,.jpg,.jpeg" />
    </label>
  </header>

  <article class="rounded-xl border border-gray-200 bg-white p-4 sm:p-6 shadow-sm min-w-0">
    @if (loading()) {
      <p class="text-sm text-gray-500">Chargement...</p>
    } @else if (kbis()?.id) {
      <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <div class="flex items-center gap-3 min-w-0">
          <span class="material-symbols-outlined text-secondary shrink-0">description</span>
          <div class="min-w-0">
            <p class="font-medium text-gray-900">Extrait KBIS disponible</p>
            <p class="text-xs text-gray-500">Mise a jour: {{ kbis()?.date | date: 'dd/MM/yyyy' }}</p>
          </div>
        </div>
        <button
          class="w-full sm:w-auto rounded-lg border border-gray-300 px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 cursor-pointer"
          (click)="downloadKbis()"
        >
          Télécharger
        </button>
      </div>
    } @else {
      <div class="flex items-start gap-3">
        <span class="material-symbols-outlined text-gray-400 shrink-0">folder_off</span>
        <div class="min-w-0">
          <p class="font-medium text-gray-900">Aucun KBIS disponible</p>
          <p class="text-sm text-gray-500 mt-1">Vous pouvez ajouter un fichier KBIS manuellement via le bouton ci-dessus.</p>
        </div>
      </div>
    }
  </article>

  <article class="rounded-xl border border-gray-200 bg-gray-50 p-4 text-sm text-gray-600">
    Pour récupérer un extrait officiel, utilisez
    <a class="text-secondary underline" href="https://www.infogreffe.fr" target="_blank" rel="noopener noreferrer">Infogreffe</a>
    ou
    <a class="text-secondary underline" href="https://www.monidenum.fr" target="_blank" rel="noopener noreferrer">MonIdenum</a>.
  </article>
  </div>
</section>
